/** Host-facing occupant profiles use the stay occupant ID, never the person UID. */
export function getPadsplitProfileUrl(opts: {
  occupantId?: string | number | null;
}): string | null {
  const value = opts.occupantId;
  if (typeof value !== "string" && typeof value !== "number") return null;
  const id = String(value);
  if (!/^[1-9]\d*$/.test(id) || !Number.isSafeInteger(Number(id))) return null;
  return `https://www.padsplit.com/host/occupant-profile/${id}`;
}

/** Validate badge hrefs without URL parser normalization of hosts, ports or fragments. */
export function validatePadsplitProfileUrl(href?: string | null): string | null {
  if (typeof href !== "string") return null;
  const match = /^https:\/\/www\.padsplit\.com\/host\/occupant-profile\/([1-9]\d*)$/.exec(href);
  return match && getPadsplitProfileUrl({ occupantId: match[1] }) === href ? href : null;
}